module.exports = __webpack_public_path__ + "static/img/sec1-cont-bg.1776d9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/xeogen/sec1-cont-bg.png
// module id = 82/9
// module chunks = 0